import template from '../../../../ui-formly/partials/form.html'
import FormControllerFactory from '../../../../ui-formly/controllers/FormControllerFactory'
import fields from './formly'
import server from '../../../server'

partPropertyEdit.vsName = 'partPropertyEdit'
partPropertyEdit.vsNgType = 'directive'

partPropertyEdit.$inject = [server.vsName]
function partPropertyEdit(server) {
  return {
    templateUrl: template,
    transclude: false,
    restrict: 'E',
    scope: {
      model: '=?'
    },
    controller: FormControllerFactory({
      returnState: '^',
      formFields: fields,
      submit: function (partProperty) {
        return server.partPropertySave(partProperty)
      }
    }),
    controllerAs: 'ctrl',
    bindToController: true
  }
}

export default partPropertyEdit